
import React from 'react';
import { ActionableAdvice } from '../../types';

interface AdviceCardProps {
    advice: ActionableAdvice;
    isHighContrast: boolean;
}

export const AdviceCard: React.FC<AdviceCardProps> = ({ advice, isHighContrast }) => {
    if (!advice) return null;
    const isAiSource = advice.id?.includes('gemini') || advice.icon === '🤖';

    // Définition des styles par sévérité
    let bgClass = 'bg-white/5 border-white/10';
    let textClass = 'text-white';
    
    if (advice.severity === 'CRITICAL') {
        bgClass = 'bg-red-500/10 border-red-500/30 shadow-[0_0_30px_rgba(239,68,68,0.1)]';
        textClass = 'text-red-400';
    } else if (advice.severity === 'SUCCESS') {
        bgClass = 'bg-emerald-500/10 border-emerald-500/30 shadow-[0_0_30px_rgba(16,185,129,0.1)]';
        textClass = 'text-emerald-400';
    }

    if (isHighContrast) {
        bgClass = "border-2 border-white bg-black";
        textClass = "text-yellow-400";
    }

    return (
        <div className={`p-5 md:p-6 rounded-[32px] flex flex-col gap-3 border transition-all ${bgClass}`}>
            <div className="flex items-center justify-between">
                <div className="flex items-center gap-3">
                    <span className="text-xl md:text-2xl drop-shadow-lg">{advice.icon || '💡'}</span>
                    <div>
                        <h5 className={`text-xs md:text-sm font-black uppercase italic tracking-tight ${textClass}`}>{advice.title}</h5>
                        <div className="flex items-center gap-2">
                            <span className={`text-[7px] md:text-[8px] font-black uppercase tracking-[0.2em] ${isHighContrast ? 'text-white' : 'text-slate-500'}`}>{advice.domain}</span>
                            <span className={`text-[7px] md:text-[8px] font-black uppercase px-1.5 py-0.5 rounded border ${isAiSource ? 'border-smart-gold text-smart-gold' : 'border-cyan-500 text-cyan-500'}`}>
                                {isAiSource ? 'AI Gemini' : 'Neural Kernel'}
                            </span>
                        </div>
                    </div>
                </div>
                <span className={`text-[8px] font-black px-3 py-1 rounded-full ${isHighContrast ? 'bg-white text-black' : (advice.severity === 'CRITICAL' ? 'bg-red-500 text-white' : advice.severity === 'SUCCESS' ? 'bg-emerald-500 text-black' : 'bg-slate-800 text-slate-400')}`}>
                    {advice.severity}
                </span>
            </div>
            <div className="space-y-2 pl-3 border-l-2 border-white/10">
                <p className={`text-[11px] md:text-xs font-medium italic leading-relaxed ${isHighContrast ? 'text-white' : 'text-slate-300'}`}>"{advice.instruction}"</p>
                <div className={`flex items-center gap-2 text-[11px] md:text-xs font-black ${isHighContrast ? 'text-yellow-300' : 'text-white'}`}>
                    <span className="text-smart-accent">👉</span> {advice.drill_hint}
                </div>
            </div>
        </div>
    );
};
